// Shared checks for the list keyboard shortcuts (tab switching, row navigation).

const isVisible = (el) => !!el && el.getClientRects().length > 0;

const isField = (el) =>
  !!el &&
  (["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName) || el.isContentEditable);

// True while a shortcut should stand down: the user is typing, or a dialog,
// drawer, menu or picker is open.
export function isTypingOrOverlayOpen(target) {
  const active = document.activeElement;
  if (isField(target) || isField(active)) return true;

  if (
    active &&
    active.closest &&
    active.closest(
      ".el-overlay, .el-dialog, .el-drawer, .el-message-box, .el-popper, .el-picker-panel, .el-select-dropdown"
    )
  ) {
    return true;
  }

  // Dialogs and drawers, plus open menus / selects / pickers (light poppers;
  // dark ones are just hover tooltips).
  return Array.from(
    document.querySelectorAll(
      ".el-overlay, .el-dialog, .el-drawer, .el-popper.is-light, .el-picker-panel"
    )
  ).some(isVisible);
}

// The visible sub-tabs under the page title (All, Active, ...) and which one is
// the current page: -1 when the page is not one of them, or there is only one.
export function getSwitchableTabs() {
  const root = document.querySelector(".navbar-filters-part");
  const links = root
    ? Array.from(root.querySelectorAll("ul.filters-list a[href]")).filter(isVisible)
    : [];
  if (links.length < 2) return { links, currentIndex: -1 };

  const pathOf = (link) =>
    new URL(link.href, window.location.origin).pathname.replace(/\/+$/, "");
  const currentPath = window.location.pathname.replace(/\/+$/, "");
  return {
    links,
    currentIndex: links.findIndex((link) => pathOf(link) === currentPath),
  };
}

// Lists announce which shortcuts they support so the Shortcuts panel in the
// header only explains what actually works on the current page.
const FLAGS = { search: "lsSearchShortcut", rows: "lsRowShortcuts" };
export const SHORTCUTS_CHANGED_EVENT = "ls-shortcuts-changed";

export function setShortcutAvailable(name, available) {
  if (available) document.body.dataset[FLAGS[name]] = "1";
  else delete document.body.dataset[FLAGS[name]];
  window.dispatchEvent(new Event(SHORTCUTS_CHANGED_EVENT));
}

export function isShortcutAvailable(name) {
  return document.body.dataset[FLAGS[name]] === "1";
}

// What the open list calls its rows ("case", "order", "sendout"), so the
// Shortcuts panel can use the same word. Empty when no list is open.
export function setRowShortcutNoun(noun) {
  if (noun) document.body.dataset.lsRowNoun = noun;
  else delete document.body.dataset.lsRowNoun;
}

export function getRowShortcutNoun() {
  return document.body.dataset.lsRowNoun || "";
}
